import React from 'react';

interface ImageLabelProps {
    imageSourceOrSvg: string;
    text: string;
    title?: string;
    className?: string;
    imageClassName?: string;
    textClassName?: string;
    textStyle?: React.CSSProperties;
    isLoading?: boolean;
}

const ImageLabel: React.FC<ImageLabelProps> = ({ 
    imageSourceOrSvg, 
    text, 
    title,
    className = '',
    imageClassName = '',
    textClassName = '',
    textStyle = { fontSize: '0.875rem' },
    isLoading = false
}) => {
    const isSvg = imageSourceOrSvg.trim().startsWith('<svg') || imageSourceOrSvg.trim().startsWith('<SVG');

    return (
        <span className={className} style={{ display: 'inline-flex', alignItems: 'center' }}>
            {isSvg ? (
                <span 
                    className={`me-1 ${imageClassName}`}
                    title={title}
                    style={{ display: 'inline-block', verticalAlign: 'middle' }}
                    dangerouslySetInnerHTML={{ __html: imageSourceOrSvg }}
                />
            ) : (
                <img 
                    src={imageSourceOrSvg} 
                    alt={text} 
                    title={title}
                    className={`me-1 ${imageClassName}`}
                    style={{ height: '1.3em', verticalAlign: 'middle' }}
                />
            )}
            {!isLoading && <span className={textClassName} title={title} style={textStyle}>{text}</span>}
        </span>
    );
};

export default ImageLabel;

